
import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { MdArrowRightAlt } from "react-icons/md";
import { HiArrowNarrowRight } from "react-icons/hi";



const Servicesfaqs = [
  {
    question: " What is a UX/UI design agency? ",
    answer:
      " A UX/UI design agency focuses on creating user-friendly interfaces and experiences for digital products like websites and mobile apps. ",
  },
  {
    question: " What does a UX/UI designer do? ",
    answer:
      " A UX/UI designer researches user needs, creates design frameworks, and delivers visuals that enhance usability and engagement. ",
  },
  {
    question: " What are UX/UI designers called? ",
    answer:
      " They are often referred to as user experience designers or interaction designers. ",
  },
  {
    question: " Is UX/UI design a tech job? ",
    answer:
      " Yes, it is a tech-focused role that combines design principles with technology to create digital experiences. ",
  },
];

const UxUiDesigning = () => {

    const navigate = useNavigate();
  

  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); 

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>
            UX/UI Designing
          </h5>
          <h2> Elevate User Experiences with Professional UX/UI Design </h2>
          <p>
            We craft exceptional digital experiences, focusing on functionality,
            aesthetics, and user satisfaction.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Schedule a Free Consultation
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2> What We Offer as UX/UI Designing Company </h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Custom UX/UI Design Solutions:
                </span>{" "}
                We create user-centric designs that enhance user experiences and
                improve engagement across web and mobile platforms.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  User Research & Strategy:
                </span>{" "}
                Our approach starts with in-depth user research to understand
                behaviors and needs, ensuring the design is relevant, intuitive,
                and aligned with your business objectives.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Mobile & Web Design Expertise:
                </span>{" "}
                We craft solutions that work effortlessly across devices and
                platforms whether you're looking for responsive web designs or
                mobile apps with seamless interfaces.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Wireframing & Prototyping:
                </span>{" "}
                We turn ideas into interactive wireframes and prototypes,
                allowing you to visualize and test your design concepts before
                development.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Usability Testing & Refinement:
                </span>{" "}
                We perform thorough usability testing to identify areas for
                improvement and refine designs to ensure maximum usability and
                satisfaction.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Talk to an Expert
              <HiArrowNarrowRight className="psec1arrow" />
            </button>
          </section>
        </section>

        <section>
          <img className="s_sec2_img1" src="../images/S_uiux_img.png" alt="" />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil for UX/UI Designing </h2>
          <p>
            Our approach integrates research, creativity, and technical
            expertise to deliver designs that not only look great but also
            provide seamless, intuitive user experiences.
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ux_sec3_img2.png" alt="" />
            <h5> Enhanced Engagement </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ux_sec3_img1.png" alt="" />
            <h5> Increased Usability </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ux_sec3_img3.png" alt="" />
            <h5> Brand Consistency </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_ux_sec3_img4.png" alt="" />
            <h5> Faster Implementation </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_ux_sec3_img5.png" alt="" />

            <h5> Unique designs </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_ux_sec3_img6.png" alt="" />

            <h5> Customer-centric </h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to Creating High-Quality Designs </h1>
        <p>
          Our approach integrates research, creativity, and technical expertise
          to deliver designs that not only look great but also provide seamless,
          intuitive user experiences. Here’s how we achieve this:
        </p>

        <ul className="Service_sec4_ul">
          <li> Understand Your Goals </li>
          <li> User-Centric Design </li>
          <li> Iterative Process </li>
          <li> Deliver Results</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      {/* Section 6 */}

      <div className="Sec8_container">
        <section>
          <h1> Ready to Improve User Experiences? </h1>
          <p>
            Contact us to discuss your design needs. Let’s build experiences
            that resonate with your audience and support your business goals.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Schedule a Free Consultation
            <MdArrowRightAlt className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default UxUiDesigning;



